import React from "react";
import { Flex, Typography } from "antd";
import PropTypes from "prop-types";
import { Icon } from "ui/Icon";
import { PreviewMediaListing } from "pagesV2/pro/Experiences/ListingPreview/PreviewMedia";
import styles from "./ExperienceBooking.module.css"

const { Text } = Typography

const ExperienceDetailBlock = ({ trip }) => {

    return (
        <>
            <Text style={{ fontSize: "18px", fontWeight: 600 }}>Experience Details</Text>
            <PreviewMediaListing trip={trip} />
            <Flex gap={12} vertical className="mt-xl">
                <Text style={{ fontSize: "18px", fontWeight: 600 }}>{trip?.title}</Text>
                <Flex gap={5} align="center">
                    <Icon type="feather" name="MapPin" width={16} height={16} />
                    <Text type="secondary" style={{ fontSize: 12 }} className={styles.primaryText}>{trip?.address}</Text>
                </Flex>
                <Flex gap={5} align="center">
                    <Icon type="feather" name="User" width={16} height={16} />
                    <Text type="secondary" style={{ fontSize: 12 }} className={styles.primaryText}>{trip?.guide?.full_name}</Text>
                </Flex>
                <Flex gap={5} align="center">
                    <Icon type="feather" name="Phone" width={16} height={16} />
                    <Text type="secondary" style={{ fontSize: 12 }} className={styles.primaryText}>{trip?.guide?.phone_number}</Text>
                </Flex>
                <Flex gap={5} align="center">
                    <Icon type="feather" name="Mail" width={16} height={16} />
                    <Text type="secondary" style={{ fontSize: 12 }} className={styles.primaryText}>{trip?.guide?.email}</Text>
                </Flex>
            </Flex>
        </>
    )
}

ExperienceDetailBlock.propTypes = {
    trip: PropTypes.shape({
        title: PropTypes.string,
        address: PropTypes.string,
        guide: PropTypes.shape({
            full_name: PropTypes.string,
            phone_number: PropTypes.string,
            email: PropTypes.string,
        }),
    }),
};

export default React.memo(ExperienceDetailBlock)